import React from 'react'
import PropTypes from 'prop-types'

import { Text } from '@maui/elements'

export const DrawerTitle = ({ children, ...props }) => {
  return <Text variant='heading3'>{children}</Text>
}

DrawerTitle.displayName = 'DrawerTitle'

DrawerTitle.propTypes = {
  children: PropTypes.node,
}
